<div class="preloader">
    <div class="preloader">
        <span></span>
        <span></span>
    </div>
</div>